const routes = [
    {
        path: '/rumours',
        component: () => import('@/pages/rumour/RumourHome.vue'),
        meta: { breadCrumb: 'Rumours', entity: 'rumour' },
        children: [
            {
                path: '',
                name: 'rumour',
                component: () => import('@/pages/rumour/RumourList.vue'),
                props: true,
                meta: { breadCrumb: 'All' },
            },
            {
                path: 'filter/:eventId?/:teamId?',
                name: 'filterRumour',
                component: () => import('@/pages/rumour/RumourList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newRumour',
                component: () => import('@/pages/rumour/RumourEditor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editRumour',
                component: () => import('@/pages/rumour/RumourEditor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readRumour',
                component: () => import('@/pages/rumour/RumourReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
            {
                path: 'archive',
                name: 'rumourArchive',
                component: () => import('@/pages/rumour/RumourArchive.vue'),
                props: true,
                meta: { breadCrumb: 'Archive' },
            },
            {
                path: 'print',
                name: 'printRumours',
                component: () => import('@/pages/rumour/RumourPrint.vue'),
                props: true,
                meta: { breadCrumb: 'Archive' },
            },
        ],
    },
]

export default routes
